import React from "react";
import { MDBContainer, MDBTypo } from "mdbreact";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";

import Layout from "../components/Layout";
import { Typography } from "@material-ui/core";

import ColourImage from "../components/ColourImage";

import text from "../text/text.json";

import header from "../images/headers/ContactHeader.jpg";
import businessCard from "../images/AW LOGO.JPG";
function Contact() {
  return (
    <>
      <Helmet>
        <title>Artistic Wizard | Contact Us</title>
      </Helmet>
      <Layout>
        <ColourImage image={header} />
        <MDBContainer style={{ padding: "20px" }}>
          <ReactMarkdown>{text.contact.body1}</ReactMarkdown>
          <ReactMarkdown>{text.contact.header2}</ReactMarkdown>
          <img src={businessCard} alt="" style={{float: 'right', margin: '10px', maxHeight:'50vh', marginTop:'50px'}}/>
          <br />
          <ReactMarkdown>{text.contact.body2}</ReactMarkdown>
          <ReactMarkdown>{text.contact.body3}</ReactMarkdown>
          <ReactMarkdown>{text.contact.header3}</ReactMarkdown>
          <MDBTypo>
            Monday - Friday 9am - 5pm                 <br />
            After Hours and Weekends - By Appointment <br />
          </MDBTypo>
          <br />
          <MDBTypo style={{ fontWeight: 'bold' }}>
            Artistic Wizard <br />
            PO BOX 744      <br />
            Glenelg SA 5045
          </MDBTypo>
          <br />
          <ReactMarkdown>{text.contact.header1}</ReactMarkdown>
          <MDBTypo>
            Mobile: +61 0418 800 904          <br />
            Email: darren@artisticwizard.com  <br />
          </MDBTypo>
          <br />
          <MDBTypo>
            <a href="https://www.facebook.com/darrenartisticwizard">facebook.com/Artistic Wizard</a>
          </MDBTypo>
          <ReactMarkdown>{text.contact.ABN}</ReactMarkdown>
        </MDBContainer>
      </Layout>
    </>
  )
}

export default Contact;